import { format } from 'date-fns'

import { DEFAULT_DATE_MASK } from '../constants'
import { dateFormatType } from '../models/IDateFormat'
import { IDatePickerInput } from '../models/IDatePickerInput'

const getMaskFormat = (dateFormat?: dateFormatType, withTime?: boolean) => {
  let mask = DEFAULT_DATE_MASK
  switch (dateFormat) {
    case 'withShortMonthName':
      mask = 'MMM do yyyy'
      break
    case 'default':
      mask = DEFAULT_DATE_MASK
      break
  }
  mask += withTime ? ' | HH:mm' : ''
  return mask
}

export const convertDateToString = (
  date?: IDatePickerInput['value'],
  isPopupInput?: boolean,
  dateFormat?: dateFormatType,
  withTime?: boolean
) => {
  if (typeof dateFormat === 'function') {
    const displayValue = dateFormat(date, !!isPopupInput)
    if (displayValue) {
      return displayValue
    }
  }

  const mask = getMaskFormat(dateFormat, withTime)

  if (!date) {
    return ''
  }
  if (date instanceof Date) {
    return format(date, mask)
  }
  if (date instanceof Array) {
    return date.map((d) => format(d, mask)).join(', ')
  }
  if (date.from || date.to) {
    const spread = '...'
    const from = date.from ? format(date.from, mask) : spread
    const to = date.to ? format(date.to, mask) : spread
    return `${from} - ${to}`
  }
  return ''
}
